import styled from 'styled-components'
import ReactSVG from 'react-svg'

export const Navigation = styled.div`
    flex: 0 0 40px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;

    background: rgba(0, 0, 0, 0.1);
`

export const Icon = styled(ReactSVG)`
    color: ${p =>
        p.disabled ? 'rgba(255, 255, 255, 0.2)' : `rgba(255, 255, 255, 0.5)`};
    cursor: ${p => (p.disabled ? 'default' : 'pointer')};
    width: 20px;
    height: 20px;
    transition: color 0.25s ease-in;

    &:hover {
        color: ${p => !p.disabled && 'white'};
    }
`

export const TooltipContainer = styled.div`
    position: absolute;
    top: 40px;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 10px;

    color: rgba(255, 255, 255, 0.6);
    background: rgba(0, 0, 0, 0.3);
    font-weight: 400;
    font-style: italic;
`



// WEBPACK FOOTER //
// ./src/components/Navigation.styles.js